import styled from '@emotion/styled';

const Paragraph = styled.div`
  font-size: 1.6rem;
  display: inline;
`;

export default Paragraph;
